import { render, staticRenderFns } from "./ChooseCard.vue?vue&type=template&id=a40f5e8c"
import script from "./ChooseCard.vue?vue&type=script&lang=js"
export * from "./ChooseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports